import React from 'react';
import SpecificComponent from '../../commons/SpecificComponent';
import { Divider, Grid, Table, TableRow, TableHead, TableCell, TableBody, FormControl, InputLabel, Select, Input, MenuItem } from '@material-ui/core';
import FromServer from './FromServer';
import Ws from '../../providers/Ws';
import Utils from '../../providers/Utils';
// import BarCharts3DRapoarteIndivid from '../chestionare/commons/charts/3dCharts/BarCharts3DRapoarteIndivid';
import Chart from 'react-google-charts'

export default class RapoarteProiect extends SpecificComponent {
    constructor(props) {
      super(props);
       this.state = {
        listUseri:[],
        chartData:[],
        objProjectData:{},
        objInfoProiect:{},
        listEtapeData:[],
        procentCuloare:'rgb(162, 47, 9)',
        sortBy:1,
        sortByList:new Utils().sortBy
     
}
    }

     componentDidMount(){

        this.getRapoarte()
        if (this.props.onChangeEvent){
            this.props.onChangeEvent(this.getRapoarte)
        }
    }
 
    getRapoarte = async() =>{
        let fs = new FromServer();

        let ws = new Ws();

        let ut = new Utils()

        

        // console.log('this.props.idproiect :', this.props.idproiect);
        let rapoarteProiect =  fs.getSituatiiGenerale(this.props.idproiect)
        let infoProiect = fs.getInfoProiect(this.props.idproiect)
        let useri  =  fs.getUsers(this.props.idproiect)
        let taskuri = fs.getTaskuriAll() 

        let [u,t, rp, p] = await Promise.all([useri, taskuri,rapoarteProiect, infoProiect])

       


            // console.log('u :', u);
            // console.log('t :', t);

            // console.log('rapoarteProiect :', rp);

            let useriClone = [...u]

        

            let taskuriClone = [...t]

            let counter1= useriClone.length

        let counter2 = taskuriClone.length

        let chartData = [['Angajat', 'Nr.Taskuri', 'Taskuri depasite', 'Taskuri finalizate in termen', 'Taskuri completate rapid']]

        for(let i =0; i<counter1; i++){

            useriClone[i].taskuri = 0
            useriClone[i].taskuri_depasite = 0
            useriClone[i].taskuri_finalizate_in_termen = 0
            useriClone[i].taskuri_finalizate_inainte_termen = 0

            for(let j = 0 ; j<counter2; j++){
                if(taskuriClone[j].id_utilizator_responsabil === useriClone[i].id){
                    // console.log('level 1 :');
                    useriClone[i].taskuri +=1

                    

                    if(taskuriClone[j].statusul !== 'Finalizat'){

                        if((new Date(taskuriClone[j].pana_cand_data) < new Date()) ){

                            useriClone[i].taskuri_depasite +=1
                        }
                    }else{


                        

                      


                     

                        
                        if((new Date(taskuriClone[j].pana_cand_data) < new Date(taskuriClone[j].cand_finalizat))){
                            useriClone[i].taskuri_depasite +=1
                        }
                        else if((new Date(taskuriClone[j].pana_cand_data) > new Date(taskuriClone[j].cand_finalizat))){

                      
                          let dataDiff =  this.calculDiferentaProcentCompletareTask(taskuriClone[j]) || 0

                        //   console.log('dataDiff :', dataDiff);

                        if(dataDiff > 20){
                            useriClone[i].taskuri_finalizate_inainte_termen += 1
                        }else{
                            useriClone[i].taskuri_finalizate_in_termen +=1
                        }

                          
                        }
                    }
             
                }

               
            }
          
            
        }

        let useriCloneSorted = useriClone.sort((a,b)=>{
            return b.taskuri - a.taskuri
        })


// console.log('useriCloneSorted :', useriCloneSorted);


        for(let i =0; i<counter1; i++){
            chartData.push([useriCloneSorted[i].nume, useriCloneSorted[i].taskuri, useriCloneSorted[i].taskuri_depasite, useriCloneSorted[i].taskuri_finalizate_in_termen, useriCloneSorted[i].taskuri_finalizate_inainte_termen])
        }

        

        let proiectClone = rp[0][0]

        proiectClone.nr_taskuri_completate_depasite_procent = ((proiectClone.nr_taskuri_completate_depasite / proiectClone.nr_total_taskuri) * 100).toFixed(1)
        proiectClone.nr_taskuri_completate_intermen_procent = ((proiectClone.nr_taskuri_completate_intermen / proiectClone.nr_total_taskuri) * 100).toFixed(1)
        proiectClone.nr_taskuri_deschise_procent = ((proiectClone.nr_taskuri_deschise / proiectClone.nr_total_taskuri) * 100).toFixed(1)
        proiectClone.nr_taskuri_deschise_depasite_procent = ((proiectClone.nr_taskuri_deschise_depasite / proiectClone.nr_total_taskuri) * 100).toFixed(1)
        proiectClone.nr_taskuri_finalizate_procent = ((proiectClone.nr_taskuri_finalizate / proiectClone.nr_total_taskuri) * 100).toFixed(1)
       

        // console.log('proiectClone :', proiectClone);

        let etapeClone = [...rp[1]]

        let counter3 = etapeClone.length

        let etapeCategorii = [{nume:'Etape Finalizate', content:[]},
                                {nume:'Etape In Lucru', content:[]},
                            {nume:'Etape in viitor', content:[]}]

        for(let i = 0; i< counter3; i++){

            etapeClone[i].durata_de_la = ut.ParseDataFromSql(etapeClone[i].durata_de_la)
            etapeClone[i].durata_pana_la = ut.ParseDataFromSql(etapeClone[i].durata_pana_la)
            etapeClone[i].nr_taskuri_completate_depasite_procent = ((etapeClone[i].nr_taskuri_completate_depasite / etapeClone[i].nr_total_taskuri) * 100).toFixed(1)
            etapeClone[i].nr_taskuri_completate_intermen_procent = ((etapeClone[i].nr_taskuri_completate_intermen / etapeClone[i].nr_total_taskuri) * 100).toFixed(1)
            etapeClone[i].nr_taskuri_deschise_procent = ((etapeClone[i].nr_taskuri_deschise / etapeClone[i].nr_total_taskuri) * 100).toFixed(1)
            etapeClone[i].nr_taskuri_deschise_depasite_procent = ((etapeClone[i].nr_taskuri_deschise_depasite / etapeClone[i].nr_total_taskuri) * 100).toFixed(1)
            etapeClone[i].nr_taskuri_finalizate_procent = ((etapeClone[i].nr_taskuri_finalizate / etapeClone[i].nr_total_taskuri) * 100).toFixed(1)
            etapeClone[i].nr_utilizatori_procent = ((etapeClone[i].nr_utilizatori/ proiectClone.nr_utilizatori) * 100).toFixed(1)

            if(etapeClone[i].statusul === 'Finalizat'){
                etapeCategorii[0].content.push(etapeClone[i])
            }else if(new Date(etapeClone[i].durata_de_la) > new Date()){
                etapeCategorii[2].content.push(etapeClone[i])
                etapeClone[i].nr_taskuri_completate_depasite = '-'
                etapeClone[i].nr_taskuri_completate_intermen = '-'
                etapeClone[i].nr_taskuri_deschise_depasite = '-'
            }else if( (new Date(etapeClone[i].durata_pana_la) < new Date()))

            etapeCategorii[1].content.push(etapeClone[i])
        }

// console.log('etapeCategorii :', etapeCategorii);
        
        // console.log('chartData :', chartData);

        // console.log('rp :', rp);

        this.setState({listUseri:useriClone,
                            chartData:chartData,
                        objProjectData:proiectClone,
                        objInfoProiect:p[0],
                    listEtapeData:etapeCategorii})
        
        
        // console.log('useriClone :', useriClone);
        
        }

        

        sortBy=(ev)=>{
            let cloneUsers = [...this.state.listUseri]

            // console.log('cloneUsers :', cloneUsers);

            // console.log('ev.target.value :', ev.target.value);
            let useriCloneSorted =[]

            let counter = cloneUsers.length

            if(ev.target.value === 1){
// console.log('taskuri :');
                useriCloneSorted = cloneUsers.sort((a,b)=>{
                    return b.taskuri - a.taskuri
                })
            }else if(ev.target.value === 2){
                // console.log('taskuri_depasite :');
                useriCloneSorted = cloneUsers.sort((a,b)=>{
                    return b.taskuri_depasite - a.taskuri_depasite
                })
            }else{

                // console.log('cost_minut :');
                useriCloneSorted = cloneUsers.sort((a,b)=>{
                    return b.cost_minut - a.cost_minut
                })
            }

            let chartData = [['Angajat', 'Nr.Taskuri', 'Taskuri depasite', 'Taskuri finalizate in termen', 'Taskuri completate rapid']]


            for(let i =0; i<counter; i++){
                chartData.push([useriCloneSorted[i].nume, useriCloneSorted[i].taskuri, useriCloneSorted[i].taskuri_depasite, useriCloneSorted[i].taskuri_finalizate_in_termen, useriCloneSorted[i].taskuri_finalizate_inainte_termen])
            }

            // console.log('chartData :', chartData);
            this.setState({
                            chartData:chartData,
                            sortBy:ev.target.value
            })

           
        }
      


        calculDiferentaProcentCompletareTask = (t) =>{

            if(!t.cand_data){
                return null ;
            }

            if(!t.cand_finalizat){
                return null;
            }

            let dataStart = new Date(t.cand_data)

            let dataFinish =t.pana_cand_data ?  new Date(t.pana_cand_data) : dataStart   // TODO VB BOGDAN

            let dataFinalizare = new Date(t.cand_finalizat) // TODO VB BOGDAN

            let durataTask = dataFinish - dataStart

            let durataCompletare = dataFinalizare - dataStart

            if(durataCompletare > durataTask){
                return null;
            }

            return ((durataTask - durataCompletare) / durataTask )* 100
            

        }
        
        
    
     render() { 
       return (
          <div>
              <div className='container'>
              <h1 className='pm-title'>{this.state.objInfoProiect.titlu}</h1>
              <h2 className='pm-title'>{this.dictionary.proiecte.rapoarteProiect.situatiiGenerale}</h2>
              <Divider className='pm-divider'/>

              <Grid container>
                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>

                        <div   style={{ backgroundColor: '#d07070b5',minHeight:100 }} className='pm-top-menu-cards' >

                              <span style={{bottom:60, fontSize:30}} className='pm-home-card-text'>
                                    {this.dictionary.proiecte.informatiiProiect.deLa}
                                </span>
                            {/* <i className='material-icons pm-top-menu-buttons-icons'>assessment</i> */}
                            <span style={{fontSize:30}} className='pm-home-card-text'>{
                                new Utils().dataPrescurtataRomana( new Utils().ParseDataFromSql(this.state.objInfoProiect.perioada_dela))}
                                </span>
                        </div>


                    </Grid>

                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>

                    <div style={{ backgroundColor: '#d07070b5',minHeight:100 }} className='pm-top-menu-cards' >
                    <span style={{bottom:60,fontSize:30}} className='pm-home-card-text'>
                         {this.dictionary.proiecte.informatiiProiect.panaLa}
                                </span>
                        {/* <i className='material-icons pm-top-menu-buttons-icons'>assessment</i> */}
                        <span style={{fontSize:30}} className='pm-home-card-text'>{
                                new Utils().dataPrescurtataRomana( new Utils().ParseDataFromSql(this.state.objInfoProiect.perioada_panala))}
                                </span>
                    </div>


                    </Grid>

                

              </Grid>

              <div style={{marginTop:30}}>
                 <Table  className='pm-indicatori-table'>
                     <TableHead>
                         <TableRow>
                             <TableCell>
                                 {this.dictionary.proiecte.rapoarteProiect.nrTaskuriCompletateDepasite}
                             </TableCell>
                             <TableCell>
                                 {this.dictionary.proiecte.rapoarteProiect.nrTaskuriCompletateInTermen}
                             </TableCell>
                             <TableCell>
                                 {this.dictionary.proiecte.rapoarteProiect.nrTaskuriDeschise}
                             </TableCell>
                             <TableCell>
                                 {this.dictionary.proiecte.rapoarteProiect.nrTaskuriDeschiseDepasite}
                             </TableCell>
                             <TableCell>
                                 {this.dictionary.proiecte.rapoarteProiect.nrTaskuriFinalizate}
                             </TableCell>
                             <TableCell>
                                 {this.dictionary.proiecte.rapoarteProiect.nrTotalTaskuri}
                             </TableCell>
                             <TableCell>
                                 {this.dictionary.proiecte.rapoarteProiect.nrUtilizatori}
                             </TableCell>
                         </TableRow>
                     </TableHead>
                     <TableBody>
                     <TableRow>
                             <TableCell>
                                 {this.state.objProjectData.nr_taskuri_completate_depasite }
                                 <span style={{color:this.state.procentCuloare}}>{`(${this.state.objProjectData.nr_taskuri_completate_depasite_procent + '%'})`}</span>
                             </TableCell>
                             <TableCell>
                             {this.state.objProjectData.nr_taskuri_completate_intermen }
                             <span style={{color:this.state.procentCuloare}}>{ `(${this.state.objProjectData.nr_taskuri_completate_intermen_procent + '%'})`}</span>
                             </TableCell>
                             <TableCell>
                             {this.state.objProjectData.nr_taskuri_deschise }
                             <span style={{color:this.state.procentCuloare}}>{`(${this.state.objProjectData.nr_taskuri_deschise_procent + '%'})`}</span>
                             </TableCell>
                             <TableCell>
                             {this.state.objProjectData.nr_taskuri_deschise_depasite }
                             <span style={{color:this.state.procentCuloare}}>{ `(${this.state.objProjectData.nr_taskuri_deschise_depasite_procent + '%'})`}</span>
                             </TableCell>
                             <TableCell>
                             {this.state.objProjectData.nr_taskuri_finalizate }
                             <span style={{color:this.state.procentCuloare}}>{ `(${this.state.objProjectData.nr_taskuri_finalizate_procent + '%'})`}</span>
                             </TableCell>
                             <TableCell>
                             {this.state.objProjectData.nr_total_taskuri}
                             </TableCell>
                             <TableCell>
                             {this.state.objProjectData.nr_utilizatori}
                             </TableCell>
                         </TableRow>

                     </TableBody>
                 </Table>

              </div>

              <h2 className='pm-title'>{this.dictionary.proiecte.rapoarteProiect.situatiiEtape}</h2>
              <Divider className='pm-divider'/>

                {this.state.listEtapeData.map((e,idx)=>{
                    return(
                        <div key={idx}>
                          <Divider className='pm-divider'/>
                            <h3 className='pm-title'>{e.nume}</h3>

                            {e.content.map((et,idx2)=>{
                                return(
                            <div key={idx2} style={{marginTop:30, marginBottom:20}}>
                           

                             <h5 style={{textAlign:'left'}} className='pm-title'>{et.denumire}</h5>
                                <Table  className='pm-indicatori-table'>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>
                                                {this.dictionary.proiecte.rapoarteProiect.nrTaskuriCompletateDepasite}
                                            </TableCell>
                                            <TableCell>
                                                {this.dictionary.proiecte.rapoarteProiect.nrTaskuriCompletateInTermen}
                                            </TableCell>
                                            <TableCell>
                                                {this.dictionary.proiecte.rapoarteProiect.nrTaskuriDeschise}
                                            </TableCell>
                                            <TableCell>
                                                {this.dictionary.proiecte.rapoarteProiect.nrTaskuriDeschiseDepasite}
                                            </TableCell>
                                            <TableCell>
                                                {this.dictionary.proiecte.rapoarteProiect.nrTaskuriFinalizate}
                                            </TableCell>
                                            <TableCell>
                                                {this.dictionary.proiecte.rapoarteProiect.nrTotalTaskuri}
                                            </TableCell>
                                            <TableCell>
                                                {this.dictionary.proiecte.rapoarteProiect.nrUtilizatori}
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                    <TableRow>
                                            <TableCell style={{whiteSpace:'nowrap'}}>
                                                {et.nr_taskuri_completate_depasite } <span style={{color:this.state.procentCuloare}}>{(et.nr_taskuri_completate_depasite !== '-' ? `(${et.nr_taskuri_completate_depasite_procent + '%'})` : '')}</span>
                                            </TableCell>
                                            <TableCell style={{whiteSpace:'nowrap'}}>
                                            {et.nr_taskuri_completate_intermen } <span style={{color:this.state.procentCuloare}}>{(et.nr_taskuri_completate_intermen !== '-' ? `(${et.nr_taskuri_completate_intermen_procent + '%'})` : '')}</span>
                                            </TableCell>
                                            <TableCell style={{whiteSpace:'nowrap'}}>
                                            {et.nr_taskuri_deschise } <span style={{color:this.state.procentCuloare}}>{`(${et.nr_taskuri_deschise_procent + '%'})`}</span>
                                            </TableCell>
                                            <TableCell style={{whiteSpace:'nowrap'}}>
                                            {et.nr_taskuri_deschise_depasite } <span style={{color:this.state.procentCuloare}}>{(et.nr_taskuri_deschise_depasite !== '-' ? `(${et.nr_taskuri_deschise_depasite_procent + '%'})` : '' )}</span>
                                            </TableCell>
                                            <TableCell style={{whiteSpace:'nowrap'}}>
                                            {et.nr_taskuri_finalizate } <span style={{color:this.state.procentCuloare}}>{`(${et.nr_taskuri_finalizate_procent + '%'})`}</span>
                                            </TableCell>
                                            <TableCell style={{whiteSpace:'nowrap'}}>
                                            {et.nr_total_taskuri}
                                            </TableCell>
                                            <TableCell style={{whiteSpace:'nowrap'}}>
                                            {et.nr_utilizatori  } <span style={{color:this.state.procentCuloare}}>{`(${et.nr_utilizatori_procent + '%'})`}</span>
                                            </TableCell>
                                        </TableRow>

                                    </TableBody>
                                </Table>

                            </div>
                                )
                            })}
                            

                        </div>
                    )
                })}

               {/* <BarCharts3DRapoarteIndivid
                        
                     
                        titlu = {'Rapoarte Indivizi'}
                        content={this.state.listUseri}
                       
                        procente={<ul className="graph-marker-container">
         <li  style={{bottom:'10%' }}><span className='graph-ruler-text'>10%</span></li>
         <li style={{bottom:'20%'}}><span className='graph-ruler-text'>20%</span></li>
         <li style={{bottom:'30%'}}><span className='graph-ruler-text'>30%</span></li>
         <li style={{bottom:'40%'}}><span className='graph-ruler-text'>40%</span></li>
         <li style={{bottom:'50%'}}><span className='graph-ruler-text'>50%</span></li>
         <li style={{bottom:'60%'}}><span className='graph-ruler-text'>60%</span></li>
         <li style={{bottom:'70%'}}><span className='graph-ruler-text'>70%</span></li>
         <li style={{bottom:'80%'}}><span className='graph-ruler-text'>80%</span></li>
         <li style={{bottom:'90%'}}><span className='graph-ruler-text'>90%</span></li>
         <li style={{bottom:'100%'}}><span className='graph-ruler-text'>100%</span></li>
     </ul>}/> */}

                        <div style={{width:'90%', margin:'auto', textAlign:'right', maxWidth:960, marginBottom:20, marginTop:60}} >
                        <FormControl className='inputFocus' style={{ width: 150, marginRight:20, marginBottom:20 }}>
                                    <InputLabel htmlFor="resursa">{this.dictionary.proiecte.rapoarteProiect.ordoneazaDupa}</InputLabel>
                                    <Select
                                     
                                        value={this.state.sortBy || ""}
                                        onChange={(ev)=>{this.sortBy(ev)}}

                                        input={<Input id="resursa" />}>

                                              
                                        {this.state.sortByList.map((t, idx) => {
                                            return <MenuItem value={t.id} key={idx}  > {t.val}</MenuItem>

                                        })
                                        }
                                    </Select>
                    </FormControl>
                        <Chart
                                                width={'100%'}
                                                height={'500px'}
                                                chartType='BarChart'

                                                data={this.state.chartData
                                                
                                                    }
                                                    options={{
                                                        title:'Rapoarte Utilizatori',
                                                    
                                                    }}
                                            
                                            />

                        </div>
                    
              </div>
         </div>
        );
       }
}